import React, { useEffect, useState } from "react";
import svg from "../../../../Assets/svg";
import { Modal } from "antd";
import { useDispatch } from "react-redux";
import { EditQuizAPI, GetQuestionsAPI } from "../../../Redux/quiz";
import { AnswerTypes } from "../QuestionBank";
import {
  ButtonWithLoader,
  PageLoader,
} from "../../../../Components/Components";

const ViewQuestionDetailsModal = ({
  isModalOpen,
  questionId,
  onClose,
  onDelete,
  onEdit,
  quizId,
}) => {
  const dispatch = useDispatch();
  const [fetching, setFetching] = useState(true);
  const [questionData, setQuestionData] = useState(null);

  const [isSaving, setIsSaving] = useState(false);

  const [savingAndAdding, setSavingAndAdding] = useState(false);

  const fetchQuestions = async () => {
    setFetching(true);
    const result = await dispatch(GetQuestionsAPI({ id: questionId }));
    if (result?.success) {
      setQuestionData(result.data.data[0]);
    }
    setFetching(false);
  };

  useEffect(() => {
    if (questionId) {
      fetchQuestions();
    }
  }, [questionId]);

  const handleSave = (addAndSaveNew = false) => {
    const payload = {
      quiz_id: quizId,
      questions: [questionId],
      isDuplicate: true,
    };

    if (addAndSaveNew) {
      setSavingAndAdding(true);
    } else {
      setIsSaving(true);
    }

    dispatch(
      EditQuizAPI(
        payload,
        () => {
          if (addAndSaveNew) {
            setSavingAndAdding(false);
            onClose(true, true);
          } else {
            setIsSaving(false);
            onClose(true, false);
          }
        },
        () => {
          if (addAndSaveNew) {
            setSavingAndAdding(false);
          } else {
            setIsSaving(false);
          }
        }
      )
    );

    // setIsSaving(true);
  };

  return (
    <Modal
      title={
        <div className="modal-header border-bottom pb-2 fw-bold fs-4 ff">
          Question Details
        </div>
      }
      open={isModalOpen}
      onCancel={() => onClose()}
      footer={
        fetching ? null : quizId ? (
          <div className="d-flex justify-content-center align-items-center gap-3">
            <ButtonWithLoader
              className="btn btn-secondary btn-lg ku-btn rounded-pill px-4  text-white bg-orange ff border-0"
              onClick={() => handleSave(false)}
              isLoading={isSaving}
              disabled={savingAndAdding}
            >
              Save
            </ButtonWithLoader>
            <ButtonWithLoader
              className="btn btn-primary btn-lg ku-btn px-4 ff"
              onClick={() => handleSave(true)}
              isLoading={savingAndAdding}
              disabled={isSaving}
            >
              Save & Add New
            </ButtonWithLoader>
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center gap-3">
            <ButtonWithLoader
              type="button"
              className="btn btn-lg btn-success min-w-124"
              onClick={() => {
                onEdit(questionId);
              }}
              isLoading={false}
            >
              Edit
            </ButtonWithLoader>
            <ButtonWithLoader
              type="button"
              className="btn btn-lg btn-danger min-w-124"
              onClick={() => {
                // setIsRejectModalOpen(true);
                // changeStatusHandler("rejected");
                onDelete(questionId);
              }}
              isLoading={false}
            >
              Delete
            </ButtonWithLoader>
          </div>
        )
      }
      centered
      closeIcon={svg?.modalClose}
      className="custom-modal"
      width={"67.5rem"}
      maskClosable={false}
    >
      {fetching ? (
        <div className="d-flex justify-content-center align-items-center px-5 py-5">
          <PageLoader />
        </div>
      ) : (
        <div className="d-flex flex-column gap-3">
          <div className="d-flex align-items-center justify-content-between">
            <label className="ff fs-6 fw-bold">{questionData?.question}</label>
            <div
              className={`fs-6 ff ${
                questionData?.ans_type !== "text" ? "text-orange" : "text-green"
              }`}
            >
              {questionData?.ans_type !== "text"
                ? "Multiple Choice"
                : "Text Area"}
            </div>
          </div>

          {questionData?.ans_type === "multiple_choice" &&
            questionData?.options &&
            questionData.options.length > 0 && (
              <div className="container px-0">
                <div className="row">
                  {questionData.options.map((opt, index) => (
                    <div className="col-6" key={index}>
                      <div className="answerOption d-flex justify-content-between align-items-center">
                        <span className="fs-6">{opt.text}</span>
                        {opt.is_correct && (
                          <span className="svg-22 d-inline-block me-3 lh-0">
                            {svg?.correctOption}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

          {questionData?.ans_type === "multiple_choice" && (
            <>
              <div className="d-flex flex-column gap-1">
                <label className="ff fs-6 fw-bold">Reflection</label>
                <p className="ff fs-6">{questionData?.reflection}</p>
              </div>

              <div className="d-flex flex-column gap-1">
                <label className="ff fs-6 fw-bold">Reference</label>
                <p className="ff fs-6">{questionData?.ay_reflection}</p>
              </div>
            </>
          )}

          <div className="d-flex flex-column gap-1">
            <label className="ff fs-6 fw-bold">Question Type</label>
            <div className="d-flex flex-wrap gap-2">
              {questionData?.tags?.map((tag, index) => (
                <span key={index} className="question_type fs-6">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ViewQuestionDetailsModal;
